var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlipCard = function SvgFlipCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.035 20.845c.567.466.941.957.941 1.51 0 .657-.509 1.222-1.266 1.755-1.506 1.062-3.987 1.85-6.947 2.222a.972.972 0 0 0 .243 1.926c3.34-.42 6.124-1.363 7.823-2.56 1.38-.973 2.09-2.147 2.09-3.343 0-1.067-.556-2.11-1.649-3.01a.972.972 0 0 0-1.235 1.5ZM15.372 26.555c-3.915-.077-7.357-.862-9.482-2.067-1.108-.628-1.866-1.306-1.866-2.134 0-.553.375-1.043.942-1.51a.971.971 0 0 0-1.235-1.498c-1.093.9-1.648 1.942-1.648 3.008 0 1.39.985 2.766 2.849 3.823 2.333 1.323 6.102 2.235 10.401 2.32a.972.972 0 0 0 .039-1.942Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.855 25.502 1.77 2.026-2.024 1.77a.97.97 0 1 0 1.277 1.463l2.756-2.411a.97.97 0 0 0 .093-1.37l-2.41-2.756a.97.97 0 1 0-1.462 1.278Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.875,
    d: "M12.439 17.514V2.767a1.25 1.25 0 0 1 1.666-1.18l6.562 2.317c.5.176.834.649.834 1.179V15.83a1.25 1.25 0 0 1-.94 1.21L14 18.726a1.25 1.25 0 0 1-1.56-1.211Z"
  })));
};
export default SvgFlipCard;